import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLocaleStore = defineStore('locale', () => {
  const flag = ref(localStorage.getItem('localeFlag') || 'gb')
  const country = ref(localStorage.getItem('localeCountry') || 'United Kingdom')

  function set(newFlag, newCountry) {
    flag.value = newFlag
    country.value = newCountry
  }

  return { flag, country, set }
})
